import React from "react";
import { useTranslation } from "react-i18next";
import { StyledTabs, StyledTab, TabsHeader } from "@rentablo/components";
import { DashboardTab } from "./useActiveTabParam";

interface Props {
  activeTab: DashboardTab;
  onChange: (tab: DashboardTab) => void;
}

export const MobileTabSwitcher = ({ activeTab, onChange }: Props) => {
  const { t } = useTranslation();

  const handleChange = (_event: React.SyntheticEvent, value: DashboardTab) => {
    onChange(value);
  };

  return (
    <TabsHeader centered={false}>
      <StyledTabs value={activeTab} onChange={handleChange}>
        <StyledTab
          label={t("components.depotsStatistic.tabs.investments")}
          value="investments"
        />
        <StyledTab
          label={t("components.depotsStatistic.tabs.bookings")}
          value="bookings"
        />
      </StyledTabs>
    </TabsHeader>
  );
};
